import React from 'react'
import { Link } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import CustomerManagement from '../components/CustomerManagement'
import UserEmailBadge from '../components/UserEmailBadge'

const CustomerManagementPage = () => {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    const { error } = await signOut()
    if (error) {
      console.error('Error signing out:', error)
    }
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center space-x-4">
              <Link
                to="/admin"
                className="text-blue-600 hover:text-blue-900 text-sm font-medium"
              >
                ← Back to Dashboard
              </Link>
              <h1 className="text-3xl font-bold text-gray-900">
                Customer Management
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <UserEmailBadge email={user?.email} />
              <button
                onClick={handleLogout}
                className="bg-[#FF1B54] hover:bg-[#E1174C] text-white px-4 py-2 rounded-md text-sm font-medium"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <CustomerManagement />
        </div>
      </main>
    </div>
  )
}

export default CustomerManagementPage
